/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ConcernRequirement
 */
export interface ConcernRequirement {
    /**
     * 
     * @type {string}
     * @memberof ConcernRequirement
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ConcernRequirement
     */
    tenant_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ConcernRequirement
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof ConcernRequirement
     */
    description?: string;
}

/**
 * Check if a given object implements the ConcernRequirement interface.
 */
export function instanceOfConcernRequirement(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "label" in value;

    return isInstance;
}

export function ConcernRequirementFromJSON(json: any): ConcernRequirement {
    return ConcernRequirementFromJSONTyped(json, false);
}

export function ConcernRequirementFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConcernRequirement {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'tenant_id': !exists(json, 'tenant_id') ? undefined : json['tenant_id'],
        'label': json['label'],
        'description': !exists(json, 'description') ? undefined : json['description'],
    };
}

export function ConcernRequirementToJSON(value?: ConcernRequirement | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'tenant_id': value.tenant_id,
        'label': value.label,
        'description': value.description,
    };
}

